<template>
    <DnPaginator
        v-bind="$attrs"
        class="dn-paginator"
        :current-page="currentPage"
        :total-pages="totalPages"
        @update:current-page="$emit('update:current-page', $event)"
    >
        <template #labelPrevious>
            <BaseIcon
                icon="chevron-left"
                class="dn-icon--square"
            />
        </template>

        <template #labelNext>
            <BaseIcon
                icon="chevron-right"
                class="dn-icon--square"
            />
        </template>
    </DnPaginator>
</template>

<script setup lang="ts">
//@ts-ignore no types
import DnPaginator from '@digitalnatives/paginator';

defineProps({
    currentPage: {
        type: Number,
        required: true
    },
    totalPages: {
        type: Number,
        required: true
    }
});

defineEmits([
    'update:current-page'
]);

</script>

<style lang="less">
.dn-paginator.dn-paginator {
    font-family: var(--font-family-secondary);
    font-weight: var(--font-weight-secondary-bold);
    --paginator-size: var(--font-size-lg);

    .dn-paginator__button.dn-button,
    .dn-paginator__next.dn-button,
    .dn-paginator__prev.dn-button {
        padding: .85rem;

        &:hover, &:focus {
            color: var(--color-primary);
            background-color: transparent;
            box-shadow: none;
        }

        &:active {
            background-color: var(--color-secondary-light);
        }
    }

    .dn-paginator__button[data-active=true].dn-button,
    .dn-paginator__next[data-active=true].dn-button,
    .dn-paginator__prev[data-active=true].dn-button {
        &, &:focus, &:hover {
            color: var(--color-primary);
            background-color: transparent;
        }
    }

    .dn-paginator__next .dn-icon,
    .dn-paginator__prev .dn-icon {
        margin: 0;
        padding-bottom: 5px;
        font-size: var(--paginator-size);
    }
}
</style>
